import { useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import getActivityTypeConf from 'src/modules/activities/ActivityTypesConf';
import { parseImagesData } from '../DragAndMatchActivity/DragAndMatchGame/parseDragAndMatchData';

export default function useCoverMenu({ activity, activityConf, gameActions }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      gameAssetsFolder: `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/${
        process.env.NEXT_PUBLIC_ROCKALINGUA_ENVIRONMENT == 'production'
          ? 'production'
          : 'staging'
      }/gamesSrc/classic/assets/${activity.data.lesson}`,
      availableTypes: [],
      availableLevels: [],
      screen: 'TYPE',
    },
    actions: {
      prepareCoverAssets: async () => {
        return {
          imagesData: parseImagesData(activity.data, state.gameAssetsFolder),
        };
      },
      startGame: (params) => {
        const mode = params?.mode;
        if (mode) {
          gameActions.setGameConf({ mode });
        }
        gameActions.startGame();
      },
    },
  });

  useEffect(() => {
    if (activity?.data) {
      const availableTypes = activity?.data.gameConf.menu.buttons.map(
        (button) => {
          const id = button.id.toLowerCase();
          if (id.includes('dragandmatch')) {
            return 'dragAndMatch';
          } else if (id.includes('wordrace') || id.includes('conceptrace')) {
            return 'conceptRace';
          } else if (id.includes('cardmatch')) {
            return 'memoryGame';
          }
        }
      );

      actions.setState({
        availableTypes,
      });
    }
  }, [activity]);

  useEffect(() => {
    if (activityConf?.level) {
      actions.setState({
        screen: 'START',
      });
    } else if (activityConf?.miniactivityType) {
      const miniactivityInitialConf = getActivityTypeConf({
        type: 'game',
        subType: 'classic',
        miniactivityType: activityConf.miniactivityType,
      });
      const gameConf = activity?.data.gameConf.menu.buttons.find((button) =>
        miniactivityInitialConf.miniactivityTypeKey.some((typeKey) =>
          button.id.toLowerCase().includes(typeKey.toLowerCase())
        )
      );

      if (gameConf.minigameConf) {
        gameActions.setGameConf({ level: 'easy' });
      } else {
        const availableLevels = gameConf.buttons.map(
          (button) => button.buttonText
        );
        actions.setState({
          availableLevels,
          screen: 'LEVEL',
        });
      }
    } else {
      actions.setState({
        screen: 'TYPE',
      });
    }
  }, [activityConf]);

  return { state, actions };
}
